import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  paper: {
    marginTop   : theme.spacing(5),
    padding     : theme.spacing(3),
    paddingRight: theme.spacing(0),
    paddingLeft : theme.spacing(0),
  },
  auditContainer: {
    display       : 'flex',
    justifyContent: 'center',
    position      : 'relative'
  },
  auditLogContainer: {
    display             : 'grid',
    gridTemplateColumns : '87% 13%',
    maxHeight           : theme.spacing(42),
    minHeight           : theme.spacing(42),
    overflowY           : 'auto',
    paddingLeft         : theme.spacing(3),
    paddingRight        : theme.spacing(3),
    width               : '100%'
  },
  loader: {
    display       : 'flex',
    justifyContent: 'center',
    width         : '100%',
  },
  logs: {
    overflow: 'hidden !important'
  }
}));